import { fromJS } from 'immutable';

import { SAVE, SAVE_SUCCESS, SAVE_FAILED, RESET_DIALOG } from './constants';

export const initialState = fromJS({
  submitting: false,
  submitDone: false,
  errorCode: undefined,
  errorMsg: undefined,
  emailVerificationRequested: false,
  duplicateNonprofitName: undefined,
  duplicateNonprofitId: undefined,
});

function registerPageReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE:
      return state.merge({
        submitting: true,
      });

    case SAVE_SUCCESS:
      return state.merge({
        emailVerificationRequested: action.emailVerificationRequested,
        submitting: false,
        submitDone: true,
        errorCode: undefined,
        errorMsg: undefined,
        duplicateNonprofitName: undefined,
        duplicateNonprofitId: undefined,
      });

    case SAVE_FAILED:
      return state.merge({
        submitting: false,
        submitDone: true,
        errorCode: action.errorCode,
        errorMsg: action.errorMsg,
        duplicateNonprofitName: action.duplicateNonprofitName,
        duplicateNonprofitId: action.duplicateNonprofitId,
      });

    case RESET_DIALOG:
      return state.merge({
        submitting: false,
        submitDone: false,
        errorCode: undefined,
        errorMsg: undefined,
        duplicateNonprofitName: undefined,
        duplicateNonprofitId: undefined,
      });

    default:
      return state;
  }
}

export default registerPageReducer;
